import React, { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ChatItem from "../Consultation/ChatItem";
import ConsultationReviewForm from "./ConsultationReviewForm";
import ReviewAction from "./ReviewAction";
import useReviewDrafts from "./useReviewDrafts";
import { getMyConsultationReviews } from "../../Services/ConsultationReviewService";
import { isCompletedConsultation, reviewStatusLabels } from "./reviewHelpers";
import "./Reviews.css";

const ConsultationReviewHistory = ({ sessions, handleJoinChat, avatar }) => {
  const [params] = useSearchParams();
  const [selectedId, setSelectedId] = useState(Number(params.get("review")) || null);
  const [reviews, setReviews] = useState([]);
  const [error, setError] = useState(false);
  const { drafts, updateDraft, clearDraft } = useReviewDrafts();
  const refresh = useCallback(async () => {
    setError(false);
    try { setReviews(await getMyConsultationReviews()); }
    catch { setError(true); }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);

  return <div dir="rtl">
    {error && <p className="review-feedback" role="alert">دریافت وضعیت نظرات ممکن نشد. <button type="button" className="review-button review-button--quiet" onClick={refresh}>تلاش دوباره</button></p>}
    {sessions.map((session) => {
      const review = reviews.find((item) => item.sessionId === session.id);
      const expanded = selectedId === session.id;
      return <div key={session.id} className="review-history-entry">
        <ChatItem session={session} handleJoinChat={handleJoinChat} isFromUser drImgSrc={avatar}
          footer={isCompletedConsultation(session) && <div className="review-history-footer">
            <span className="review-muted m-0">{review ? reviewStatusLabels[review.status] : "مشاوره پایان‌یافته"}</span>
            <ReviewAction review={review} expanded={expanded} controls={`session-review-${session.id}`} onClick={() => setSelectedId(expanded ? null : session.id)} />
          </div>} />
        {isCompletedConsultation(session) && <>
          {expanded && <div id={`session-review-${session.id}`}><ConsultationReviewForm key={session.id} session={session} draft={drafts[session.id]} onDraftChange={(draft) => updateDraft(session.id, draft)} onSubmitted={(saved) => { clearDraft(saved.sessionId); setReviews((items) => [...items.filter((item) => item.sessionId !== saved.sessionId), saved]); }} /></div>}
        </>}
      </div>;
    })}
  </div>;
};

export default ConsultationReviewHistory;
